module.exports = __webpack_public_path__ + "assets/img/1.799d8302.png";